// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { APPBaseElement } from './APPBaseElement';
import { APPComponent } from './APPComponent';
import { TaskSequence } from './TaskSequence';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 定时任务 实体类
 * 定时任务
 */
export class Task extends APPBaseElement {
  /** 开始小时 : 开始小时，24小时制，大于等于此小时数则开始执行 */
  private _beginHour: number;

  /** 设置：开始小时 */
  public get beginHour() {
    return this._beginHour;
  }

  /** 获取：开始小时 */
  public set beginHour(value: number) {
    this._beginHour = value;
  }

  /** 结束小时 : 结束小时，24小时制，小于等于此小时数则开始执行 */
  private _endHour: number;

  /** 设置：结束小时 */
  public get endHour() {
    return this._endHour;
  }

  /** 获取：结束小时 */
  public set endHour(value: number) {
    this._endHour = value;
  }

  /** 是否启用 : 是否启用 */
  private _isValid: boolean;

  /** 设置：是否启用 */
  public get isValid() {
    return this._isValid;
  }

  /** 获取：是否启用 */
  public set isValid(value: boolean) {
    this._isValid = value;
  }

  /** 执行频率 : 任务执行频率，使用Cron表达式 */
  private _frequency: string;

  /** 设置：执行频率 */
  public get frequency() {
    return this._frequency;
  }

  /** 获取：执行频率 */
  public set frequency(value: string) {
    this._frequency = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: APPComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: APPComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 任务顺序关系集合（当前为前置任务） */
  private _beforeTaskSequences: Array<TaskSequence>;

  /** 获取：任务顺序关系集合（当前为前置任务） */
  public get beforeTaskSequences() {
    return this._beforeTaskSequences;
  }

  /** 设置：任务顺序关系集合（当前为前置任务） */
  public set beforeTaskSequences(value: Array<TaskSequence>) {
    this._beforeTaskSequences = value;
  }

  /** 任务顺序关系集合（当前为后置任务） */
  private _afterTaskSequences: Array<TaskSequence>;

  /** 获取：任务顺序关系集合（当前为后置任务） */
  public get afterTaskSequences() {
    return this._afterTaskSequences;
  }

  /** 设置：任务顺序关系集合（当前为后置任务） */
  public set afterTaskSequences(value: Array<TaskSequence>) {
    this._afterTaskSequences = value;
  }

  constructor() {
    super();
    this._beginHour = 0;
    this._endHour = 0;
    this._isValid = false;
    this._frequency = '';
    this._component_ID = '';
    this._component = null;
    this._beforeTaskSequences = new Array<TaskSequence>();
    this._afterTaskSequences = new Array<TaskSequence>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Task, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.beginHour = element.beginHour;
      this.endHour = element.endHour;
      this.isValid = element.isValid;
      this.frequency = element.frequency;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.beginHour = json.BeginHour;
    this.endHour = json.EndHour;
    this.isValid = json.IsValid;
    this.frequency = json.Frequency;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = APPComponent.Create(json.Component);
    // }
    if (json.BeforeTaskSequences && json.BeforeTaskSequences.length > 0) {
      json.BeforeTaskSequences.forEach((element: any) => {
        const taskSequence = TaskSequence.Create(element);
        // taskSequence.beforeTask = this;
        this.beforeTaskSequences.push(taskSequence);
      });
    }
    if (json.AfterTaskSequences && json.AfterTaskSequences.length > 0) {
      json.AfterTaskSequences.forEach((element: any) => {
        const taskSequence = TaskSequence.Create(element);
        // taskSequence.afterTask = this;
        this.afterTaskSequences.push(taskSequence);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.BeginHour = this.beginHour;
    json.EndHour = this.endHour;
    json.IsValid = this.isValid;
    json.Frequency = this.frequency;
    json.Component_ID = this.component_ID;
    if (this.beforeTaskSequences && this.beforeTaskSequences.length > 0) {
      json.BeforeTaskSequences = [];
      this.beforeTaskSequences.forEach((element) => {
        json.BeforeTaskSequences.push(element.toJson());
      });
    }
    if (this.afterTaskSequences && this.afterTaskSequences.length > 0) {
      json.AfterTaskSequences = [];
      this.afterTaskSequences.forEach((element) => {
        json.AfterTaskSequences.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'beginHour', '开始小时', EnumDataType.Int, this.beginHour, true, '开始小时，24小时制，大于等于此小时数则开始执行', '', '');
    context.addRow('基本属性', 'endHour', '结束小时', EnumDataType.Int, this.endHour, true, '结束小时，24小时制，小于等于此小时数则开始执行', '', '');
    context.addRow('基本属性', 'isValid', '是否启用', EnumDataType.Bool, this.isValid, true, '是否启用', '', '');
    context.addRow('基本属性', 'frequency', '执行频率', EnumDataType.String, this.frequency, true, '任务执行频率，使用Cron表达式', '', '');
    return context;
  }

  static Create(json: any): Task {
    const task = new Task();
    task.Deserialize(json);
    task.json = json;
    return task;
  }
}
